import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Button, Card, CardMedia, CardContent, CardActions, CardActionArea, Dialog, DialogTitle, DialogContentText, DialogContent, DialogActions, CircularProgress } from '@material-ui/core/';

import links from 'utils/links';
import { getCityName } from 'utils/';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import swal from 'sweetalert';

const styles = {
  card: {
    maxWidth: 345,
  },
  media: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: 'cover',
  },
};

class DeleteArticle extends React.Component {
  state = {
    open: false,
  };
  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  componentDidUpdate(prevProps) {
    if (prevProps.loader && !this.props.loader) {
      this.setState({ open: false });
      swal({
        text: 'Article Successfully Deleted !',
        position: 'center center',
      });
      setTimeout(function () { window.location.reload(); }, 1000);
    }
  }
  render() {
    let { data, onDelete, loader } = this.props;
    return (
      <div>
        <Button onClick={this.handleClickOpen} size="small" variant="outlined" color="secondary">
          Delete
        </Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Delete Article</DialogTitle>
          {
            loader ? <DialogContent>
              <div style={{ "textAlign": "center", "verticalAlign": "middle" }}>
                <CircularProgress /> <br />
                Deleting Article ...
              </div>
            </DialogContent> :
              <div>
                <DialogContent>
                  <DialogContentText>
                    Are you sure, you want to delete,
                </DialogContentText>
                  <Typography gutterBottom variant="h6" component="h4" color="primary">
                    "{data.title}?"
                </Typography>
                  <DialogContentText>
                    Once Deleted, the Artcile can't be recovered!
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose} size="small" variant="outlined" color="primary">
                    Cancel
                </Button>
                  <Button onClick={onDelete} size="small" variant="outlined" color="secondary">
                    Delete
                </Button>
                </DialogActions>
              </div>
          }
        </Dialog>
      </div>
    );
  }
}

class DashboardArticle extends React.Component {
  render() {
    const { classes, data, draft, onDelete, deleteLoader } = this.props;
    let cityName = getCityName();
    let editLink = "";
    let viewLink = "";
    data.city = data.city ? data.city : (data.resourceType === "STORY") ? [{}] : {};
    if (data.resourceType === "EATERY") {
      cityName = data.city.name ? data.city.name : cityName;
      editLink = links.eateryEdit(cityName, data.linkTitle);
      viewLink = links.eatery(cityName, data.linkTitle);
    }
    else if (data.resourceType === "LISTICLE") {
      cityName = data.city.name ? data.city.name : cityName;
      editLink = links.listiclesAddEditLinks(data.id);
      viewLink = links.listicleWithCity(cityName, data.linkTitle);
    }
    else if (data.resourceType === "STORY") {
      cityName = data.city.name ? data.city.name : cityName;
      editLink = links.storyEditMode(data.linkTitle);
      viewLink = links.storyWithCity(cityName, data.linkTitle);
    }
    return (
      <Card className={classes.card}>
        <CardActionArea>
          <CardMedia
            component="img"
            alt="Sample"
            className={classes.media}
            height="140"
            image={data.imageUrl ? data.imageUrl : '/img/na.png'}
            title="Sample"
          />
          <CardContent>
            <Typography gutterBottom variant="h6" component="h4">
              {data.title}
            </Typography>
            <Typography component="p">
              Last Modified on : {format(data.updatedAt, 'MMM DD YYYY')}
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Link to={editLink}>
            <Button size="small" variant="outlined" color="primary">
              Edit
            </Button>
          </Link>
          {
            draft ? "" : <Link to={viewLink}>
              <Button size="small" variant="outlined" color="primary">
                View
              </Button>
            </Link>
          }
          <DeleteArticle loader={deleteLoader} data={data} onDelete={() => onDelete(data)} />
        </CardActions>
      </Card>
    );
  }
}

DashboardArticle.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DashboardArticle);
